export default {
  // 页面标题
  'adsAgent.title': '代理归因绑定',

  // 搜索字段
  'adsAgent.agentNameChoose': '选择代理',
  'adsAgent.dateRange': '操作时间',

  // 按钮
  'adsAgent.search': '查询',
  'adsAgent.reset': '重置',
  'adsAgent.add': '新增',
  'adsAgent.addAdsAgent': '新增代理归因绑定',
  'adsAgent.delete': '删除',
  'adsAgent.save': '保存',
  'adsAgent.cancel': '取消',

  // 表格列
  'adsAgent.serial': '序号',
  'adsAgent.agentName': '代理名称',
  'adsAgent.adsName': '归因配置名称',
  'adsAgent.adsType': '归因渠道',
  'adsAgent.operator': '操作人',
  'adsAgent.operationTime': '操作时间',
  'adsAgent.action': '操作',

  // 表单标签
  'adsAgent.adsAccount': '归因配置',

  // 表单验证
  'adsAgent.agentNameRequired': '请选择代理',
  'adsAgent.adsTypeRequired': '请选择归因渠道',
  'adsAgent.adsAccountRequired': '请选择归因配置',

  // 消息提示
  'adsAgent.addSuccess': '新增成功',
  'adsAgent.addFailed': '新增失败',
  'adsAgent.deleteSuccess': '删除成功',
  'adsAgent.deleteFailed': '删除失败',
  'adsAgent.confirmDelete': '确认删除此条记录吗？',
  'adsAgent.fetchTypesFailed': '获取归因平台类型失败',
  'adsAgent.fetchAdsAccountsFailed': '获取归因配置列表失败',
  'adsAgent.fetchAgentsFailed': '获取代理列表失败',

  // 分页
  'adsAgent.totalRecords': '共 {total} 条记录',
  'adsAgent.pagination': '第 {current} 页，共 {page} 页，总计 {total} 条记录',
};
